import React, {Component} from 'react';



class GetStartedForm extends Component{

    componentDidMount() {
      }

    render(){
        return(
            <div className="get-started-form">
                <form>
                    <h3 className="get-started-title">دراسة جدوى أولية</h3>
                    <div className="form-group project-name-fg">
                      {/* <input className="form-control cassandra-form-control"  type="text"   placeholder="إسم الدراسة الجديدة..."/>*/} 
                    </div>
                    <div className="main-info-box">
                        <ul className="list-unstyled steps-list">
                            <li className="step-name active-step">معلومات أساسية</li>
                            <li className="step-name">دراسة السوق</li>
                            <li className="step-name">التكاليف</li>
                            <li className="step-name">المبيعات</li>
                            <li className="step-name">تحليل SWOT</li>
                        </ul>

                        <div className="form-steps">
                            <div className="form-step form-active-step">
                                <h4 className="main-info-title">معلومات أساسية</h4>
                                <div className="main-info-box-form">

                                  <div className="row">
                                        <div className="col-lg-6">
                                            <div className="form-group cassandra-form-group">
                                                <label>اسم الدراسة </label>
                                                <input   className="form-control cassandra-form-control" type="text" placeholder="اسم الدراسة"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                       <div className="col-lg-6">
                                            <div className="form-group cassandra-form-group">
                                                <label>اسم المشروع </label>
                                                <input   className="form-control cassandra-form-control" type="text" placeholder="اسم المشروع"/>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group cassandra-form-group">
                                                <label>تاريخ بدء المشروع </label>
                                                <input   className="form-control cassandra-form-control" type="date" placeholder="تاريخ البدء"/>
                                            </div>
                                        </div>
                                        
                                    </div>
                                   
                                    <div className="form-group cassandra-form-group">
                                        <label>نبذة عن المشروع</label>
                                        <textarea className="form-control cassandra-form-control" rows="3"  placeholder="نبذة عن المشروع ..."/>
                                    </div>
                                   
                                    <div className="row">
                                        <div className="form-group cassandra-form-group col-lg-3">
                                            <label>العملة</label>
                                                <select className="form-control cassandra-form-control" >
                                                    <option className="cassandra-form-control"  > اختر عملتك  </option>
                                                    <option className="cassandra-form-control"  > دولار أمريكي  </option>
                                                    <option className="cassandra-form-control"  > ريال سعودي  </option>
                                                    <option className="cassandra-form-control"  > درهم اماراتي  </option>
                                                    <option className="cassandra-form-control"  > مصري  </option>
                                                </select>
                                        </div>  
                                        <div className="form-group cassandra-form-group col-lg-3">
                                            <label>الاعشار</label>
                                                <select className="form-control cassandra-form-control" >
                                                    <option className="cassandra-form-control" selected > X  </option>
                                                    <option className="cassandra-form-control"  > X.X  </option>
                                                    <option className="cassandra-form-control"  > X.XX   </option>
                                                    <option className="cassandra-form-control"  > X.XXX  </option>
                                                </select>
                                        </div>  
                                        <div className="form-group cassandra-form-group col-lg-3">
                                            <label>مدة الدراسة</label>
                                                <select className="form-control cassandra-form-control" >
                                                    <option className="cassandra-form-control" selected > سنة </option>
                                                    <option className="cassandra-form-control"  > سنتان </option>
                                                    <option className="cassandra-form-control"  > ثلاث سنوات </option>
                                                    <option className="cassandra-form-control"  > خمس سنوات </option>
                                                    <option className="cassandra-form-control"  > عشر سنوات </option>
                                                    <option className="cassandra-form-control"  > خمسة عشر سنة </option>
                                                </select>
                                        </div>   
                                        <div className="form-group cassandra-form-group col-lg-3">
                                            <label> الضريبة VAT  </label>
                                            <input   className="form-control cassandra-form-control" type="text" placeholder="...%"/>
                                        </div>     
                                    </div>


                                    <div className="form-group cassandra-form-group">
                                        <label>جدوى تنظيمية</label>
                                        <textarea className="form-control cassandra-form-control" rows="4"  placeholder="تفاصيل الجدوى الإدارية ..."/>
                                    </div>
                                            <div className="owner-section">
                                                 <h4 className="main-info-title owner-list-title">قائمة الملاك</h4>
                                                 <button className="getstart-add-btn red-btn add-new-owner" type="button" > إضافة مالك جديد </button> 
                                            </div>

                                          <div className="row owner-list">
                                            <div className="col-lg-4">
                                                <div className="form-group cassandra-form-group">
                                                    <label>اسم المالك </label>
                                                    <input   className="form-control cassandra-form-control" type="text" placeholder="اسم المالك"/>
                                                </div>
                                             </div>
                                             <div className="col-lg-3">
                                                <div className="form-group cassandra-form-group">
                                                    <label>نسبة الملكية </label>
                                                    <input   className="form-control cassandra-form-control" type="number" placeholder="نسبة المالك %"/>
                                                </div>
                                             </div>

                                             <div className="col-lg-4">
                                                <div className="form-group cassandra-form-group">
                                                    <label>خبرات المالك </label>
                                                    <input   className="form-control cassandra-form-control" type="text" placeholder="الخبرات "/>
                                                </div>
                                             </div>
                                             <div className="col-lg-1">
                                                <div className="form-group cassandra-form-group">
                                                    <label>حذف </label>
                                                    <button className="getstart-add-btn delete-btn delete-new-owner " type="button" >X</button> 
                                                </div>
                                             </div>
                                            
                                              
                                          </div>
                                          

                                     <div className="mt-4 mb-3 text-center">
                                       <button className="form-step-next submit-btn" type="button">التالي</button>
                                    </div>

                                </div>
                            </div>
                            <div className="form-step">
                                <h4 className="main-info-title">دراسة السوق </h4>
                                <div className="main-info-box-form">

                                <div className="row">
                                       <div className="col-lg-6">
                                            <div className="form-group cassandra-form-group">
                                                <label>اسم القطاع </label>
                                                <input   className="form-control cassandra-form-control" type="text" placeholder="السوق المستهدف ..."/>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group cassandra-form-group">
                                                <label>حجم التداول </label>
                                                <input   className="form-control cassandra-form-control" type="number" placeholder="حجم التداول السنوي"/>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div className="form-group cassandra-form-group">
                                        <label>عن السوق</label>
                                        <textarea className="form-control cassandra-form-control" rows="3"  placeholder="اكتب نبذة عن السوق المستهدف ..."/>
                                    </div>

                                    <div className="form-group cassandra-form-group">
                                        <label>منتجات وخدمات القطاع</label>
                                        <textarea className="form-control cassandra-form-control" rows="3"  placeholder="اكتب نبذة عن منتجاتك وخدماتك في هذا القطاع ..."/>
                                    </div>
                                    <div className="form-group cassandra-form-group">
                                        <label>الفئة المستهدفة </label>
                                        <textarea className="form-control cassandra-form-control" rows="3"  placeholder="اكتب نبذة عن الفئة المستهدفة ..."/>
                                    </div>
                                    <div className="form-group cassandra-form-group">
                                        <label>الموردين </label>
                                        <textarea className="form-control cassandra-form-control" rows="3"  placeholder="اكتب نبذة عن الموردين ..."/>
                                    </div>
                                    <div className="form-group cassandra-form-group">
                                        <label>خطة التسويق </label>
                                        <textarea className="form-control cassandra-form-control" rows="3"  placeholder="اكتب نبذة عن خطتك التسويقية ..."/>
                                    </div>
                                    
                              

                       

                                <h4 className="main-info-title">المنافسين </h4>

                                    <div className="form-group cassandra-form-group">
                                            <label>المنافسة  </label>
                                            <textarea className="form-control cassandra-form-control" rows="3"  placeholder="تحليل المنافسة في السوق ..."/>
                                    </div>

                                         <button className="getstart-add-btn red-btn add-new-competitor" type="button" > إضافة منافس جديد</button> 

                                    <div className="row competitors-list">
                                            <div className="col-lg-4">
                                                <div className="form-group cassandra-form-group">
                                                    <label>اسم المنافس </label>
                                                    <input   className="form-control cassandra-form-control" type="text" placeholder="اسم المنافس"/>
                                                </div>
                                             </div>
                                             <div className="col-lg-3">
                                                <div className="form-group cassandra-form-group">
                                                    <label>الحصة السوقية  </label>
                                                    <input   className="form-control cassandra-form-control" type="number" placeholder="حسة المنافس السوقية %"/>
                                                </div>
                                             </div>

                                             <div className="col-lg-4">
                                                <div className="form-group cassandra-form-group">
                                                    <label>أوجة المنافسة </label>
                                                    <input   className="form-control cassandra-form-control" type="text" placeholder="أوجة المنافسة  "/>
                                                </div>
                                             </div>
                                             <div className="col-lg-1">
                                                <div className="form-group cassandra-form-group">
                                                    <label>حذف </label>
                                                    <button className="getstart-add-btn delete-btn delete-new-competitor " type="button" >X</button> 
                                                </div>
                                             </div>
                                            
                                              
                                          </div>


                                     <div className="mt-4 mb-3 text-center">
                                         <button className="form-step-prev submit-btn yellow-btn ml-2" type="button">السابق</button>
                                       <button className="form-step-next submit-btn" type="button">التالي</button>
                                    </div>

                                </div>
                            </div>
                            <div className="form-step form-step-3">
                                <h4 className="main-info-title">تكاليف التأسيس </h4>
                                <div className="main-info-box-form">
                                    <button className="getstart-add-btn red-btn add-new-main-cost" type="button" >  إضافة تكلفة جديدة  </button> 
                                 <div className="row main-costs-list">
                                            <div className="col-lg-3">
                                                <div className="form-group cassandra-form-group">
                                                    <label>الأصل </label>
                                                    <input   className="form-control cassandra-form-control" type="text" placeholder="اسم الأصل"/>
                                                </div>
                                             </div>
                                             <div className="col-lg-3">
                                                <div className="form-group cassandra-form-group">
                                                    <label>التكلفة   </label>
                                                    <input   className="form-control cassandra-form-control" type="number" placeholder="تكلفة الأصل"/>
                                                </div>
                                             </div>

                                             <div className="col-lg-3">
                                             <div className="form-group cassandra-form-group">
                                                 <label>العمر   </label>
                                                 <input   className="form-control cassandra-form-control" type="number" placeholder="العمر"/>
                                             </div>
                                          </div>

                                             <div className="col-lg-2">
                                                <div className="form-group cassandra-form-group">
                                                    <label>الإهلاك </label>
                                                    <input   className="form-control cassandra-form-control" type="number" placeholder="الإهلاك  "/>
                                                </div>
                                             </div>
                                             <div className="col-lg-1">
                                               <div className="form-group cassandra-form-group">
                                                    <label>حذف </label>
                                                    <button className="getstart-add-btn delete-btn delete-new-main-cost " type="button" >X</button> 
                                                </div>
                                             </div>
                                            
                                              
                                          </div>

                                <h4 className="main-info-title">المديونيات </h4>

                                <button className="getstart-add-btn red-btn add-new-dept" type="button" >  إضافة مديونية جديدة  </button> 


                                     <div className="row depts-list">
                                          <div className="col-lg-3">
                                              <div className="form-group cassandra-form-group">
                                                  <label>الجهة   </label>
                                                  <input   className="form-control cassandra-form-control" type="text" placeholder="اسم البنك أو الجهة المقردة"/>
                                              </div>
                                           </div>
                                           <div className="col-lg-3">
                                              <div className="form-group cassandra-form-group">
                                                  <label>القيمة   </label>
                                                  <input   className="form-control cassandra-form-control" type="number" placeholder="قيمة القرض"/>
                                              </div>
                                           </div>

                                           <div className="col-lg-3">
                                           <div className="form-group cassandra-form-group">
                                               <label>الفائدة   </label>
                                               <input   className="form-control cassandra-form-control" type="number" placeholder="نسبة الفائدة"/>
                                           </div>
                                        </div>

                                           <div className="col-lg-2">
                                              <div className="form-group cassandra-form-group">
                                                  <label>المدة  </label>
                                                  <input   className="form-control cassandra-form-control" type="number" placeholder="المدة "/>
                                              </div>
                                           </div>
                                           <div className="col-lg-1">
                                                  <div className="form-group cassandra-form-group">
                                                    <label>حذف </label>
                                                    <button className="getstart-add-btn delete-btn delete-new-dept " type="button" >X</button> 
                                                </div>
                                           </div>
                                          
                                            
                                        </div>


                                <h4 className="main-info-title">التكاليف الشهرية الثابتة</h4>
                                   <button className="getstart-add-btn red-btn add-new-monthly-cost" type="button" >  إضافة تكلفة شهرية  </button> 


                                     <div className="row monthly-costs-list">
                                          <div className="col-lg-6">
                                              <div className="form-group cassandra-form-group">
                                                  <label>التكلفة    </label>
                                                  <input   className="form-control cassandra-form-control" type="text" placeholder="اسم التكلفة الثابتة..."/>
                                              </div>
                                           </div>
                                           <div className="col-lg-5">
                                              <div className="form-group cassandra-form-group">
                                                  <label>القيمة   </label>
                                                  <input   className="form-control cassandra-form-control" type="number" placeholder="قيمة التكلفة شهريا ..."/>
                                              </div>
                                           </div>

                                           <div className="col-lg-1">
                                              <div className="form-group cassandra-form-group">
                                                    <label>حذف </label>
                                                    <button className="getstart-add-btn delete-btn delete-new-monthly-cost " type="button" >X</button> 
                                                </div>
                                           </div>
                                          
                                            
                                      </div>

                                <h4 className="main-info-title">الموظفين</h4>
                                 <button className="getstart-add-btn red-btn add-new-job" type="button" >  إضافة وظيفة جديدة  </button> 


                                    <div className="row jobs-list">
                                          <div className="col-lg-5">
                                              <div className="form-group cassandra-form-group">
                                                  <label>الوظيفة     </label>
                                                  <input   className="form-control cassandra-form-control" type="text" placeholder="المسمى الوظيفي..."/>
                                              </div>
                                           </div>
                                           <div className="col-lg-3">
                                              <div className="form-group cassandra-form-group">
                                                  <label>الراتب   </label>
                                                  <input   className="form-control cassandra-form-control" type="number" placeholder="قيمة الراتب الشهري"/>
                                              </div>
                                           </div>
                                           <div className="col-lg-3">
                                              <div className="form-group cassandra-form-group">
                                                  <label>العدد   </label>
                                                  <input   className="form-control cassandra-form-control" type="number" placeholder="عدد الموظفين"/>
                                              </div>
                                           </div>

                                           <div className="col-lg-1">
                                                 <div className="form-group cassandra-form-group">
                                                    <label>حذف </label>
                                                    <button className="getstart-add-btn delete-btn delete-new-job " type="button" >X</button> 
                                                </div>
                                           </div>
                                          
                                            
                                      </div>


                                   

                                     <div className="mt-4 mb-3 text-center">
                                         <button className="form-step-prev submit-btn yellow-btn ml-2" type="button">السابق</button>
                                       <button className="form-step-next submit-btn" type="button">التالي</button>
                                    </div>

                                </div>
                            </div>
                            <div className="form-step form-step-4">
                                <h4 className="main-info-title">المنتجات وإيرادها الشهري </h4>
                                <div className="main-info-box-form">

                                <button className="getstart-add-btn red-btn add-new-product" type="button" >  إضافة منتج جديد  </button> 
                                        <div className="products-list">

                                                <div className="row">
                                                    <div className="col-lg-4">
                                                        <div className="form-group cassandra-form-group">
                                                            <label>المنتج     </label>
                                                            <input   className="form-control cassandra-form-control" type="text" placeholder="اسم المنتج..."/>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group cassandra-form-group">
                                                            <label>التكلفة   </label>
                                                            <input   className="form-control cassandra-form-control" type="number" placeholder="تكلفة المواد"/>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <div className="form-group cassandra-form-group">
                                                            <label>السعر   </label>
                                                            <input   className="form-control cassandra-form-control" type="number" placeholder="سعر المنتج"/>
                                                        </div>
                                                    </div>
                                                        
                                                </div>

                                                <div className="row">
                                                        <div className="col-lg-4">
                                                            <div className="form-group cassandra-form-group">
                                                                <label>البيع الشهري     </label>
                                                                <input   className="form-control cassandra-form-control" type="number" placeholder="قدرة البيع الشهري..."/>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="form-group cassandra-form-group">
                                                                <label>الانتاج الشهري   </label>
                                                                <input   className="form-control cassandra-form-control" type="number" placeholder="قدرة انتاج شهري"/>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="form-group cassandra-form-group">
                                                                <label>الزيادة السنوية </label>
                                                                <input   className="form-control cassandra-form-control" type="number" placeholder="نسبة الزيادة %"/>
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-1">
                                                                <div className="form-group cassandra-form-group">
                                                                    <label>حذف </label>
                                                                    <button className="getstart-add-btn delete-btn delete-new-product " type="button" >X</button> 
                                                                </div>
                                                            </div>
                                                </div>
                                        </div>

                                     <div className="mt-4 mb-3 text-center">
                                         <button className="form-step-prev submit-btn yellow-btn ml-2" type="button">السابق</button>
                                       <button className="form-step-next submit-btn" type="button">التالي</button>
                                    </div>

                                </div>
                            </div>
                            <div className="form-step form-step-5">
                                <h4 className="main-info-title">تحليل SWOT </h4>
                                <div className="main-info-box-form">

                                 <div className="row">
                                        <div className="col-lg-6">
                                            <div className="form-group cassandra-form-group">
                                                <label>نقاط القوة      </label>
                                                <textarea   className="form-control cassandra-form-control" type="text" rows="5" placeholder="نقاط القوة Strength"/>
                                            </div>
                                        </div>
                                       

                                          <div className="col-lg-6">
                                            <div className="form-group cassandra-form-group">
                                                <label>نقاط الضعف     </label>
                                                <textarea   className="form-control cassandra-form-control" type="text" rows="5" placeholder="نقاط الضفعف Weakness"/>
                                            </div>
                                        </div>
                                        
                                    </div>

                                     <div className="row">
                                        <div className="col-lg-6">
                                            <div className="form-group cassandra-form-group">
                                                <label>الفرص      </label>
                                                <textarea   className="form-control cassandra-form-control" type="text" rows="5"  placeholder="الفرص Oppourtunity"/>
                                            </div>
                                        </div>
                                       

                                          <div className="col-lg-6">
                                            <div className="form-group cassandra-form-group">
                                                <label>المخاطر     </label>
                                                <textarea   className="form-control cassandra-form-control" type="text" rows="5"  placeholder="المخاطر Threat"/>
                                            </div>
                                        </div>
                                       
                                    </div>

                                  
                                   


                                     <div className="mt-4 mb-3 text-center">
                                        <button className="form-step-prev submit-btn yellow-btn ml-2" type="button">السابق</button>
                                        <button className="submit-btn" type="button">انهاء</button>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                
                </form>
            </div>
        );
    }

};
export default GetStartedForm;
